import { SvgIcon } from '@mui/material';
import { Id } from 'react-toastify';
import { toastColors } from 'style/colors';
import CancelV1Icon from '../Icons/CancelV1Icon';
import CheckCircleV1Icon from '../Icons/CheckCircleV1Icon';
import CloseErrorV1Icon from '../Icons/CloseErrorV1Icon';
import CloseInfoV1Icon from '../Icons/CloseInfoV1Icon';
import CloseLoadingV1Icon from '../Icons/CloseLoadingV1Icon';
import CloseSuccessV1Icon from '../Icons/CloseSuccessV1Icon';
import InfoV1Icon from '../Icons/InfoV1Icon';
import LoadingInfoV1Icon from '../Icons/LoadingInfoV1Icon';

export const TOAST_DEFAULT_DURATION = 5000;

export const RETRY_UPLOAD_TOAST_ID: Id = 'retry-upload-toast-id';

export const ToastTypeEnum = {
  SUCCESS: 'success',
  INFO: 'info',
  ERROR: 'error',
  LOADING: 'loading',
} as const;

export type TToastType = (typeof ToastTypeEnum)[keyof typeof ToastTypeEnum];
type SvgIconType = typeof SvgIcon;

export const toastIconMap: Record<TToastType, SvgIconType> = {
  success: CheckCircleV1Icon,
  info: InfoV1Icon,
  error: CancelV1Icon,
  loading: LoadingInfoV1Icon,
};

export const gradientColorByType: Record<TToastType, string> = {
  success: toastColors.successGradientBase,
  info: toastColors.warningGradientBase,
  error: toastColors.errorGradientBase,
  loading: toastColors.infoGradientBase,
};

export const colorByType: Record<TToastType, string> = {
  success: toastColors.success,
  info: toastColors.info,
  error: toastColors.error,
  loading: toastColors.info,
};

export const closeButtonIconMap: Record<TToastType, SvgIconType> = {
  success: CloseSuccessV1Icon,
  info: CloseInfoV1Icon,
  error: CloseErrorV1Icon,
  loading: CloseLoadingV1Icon,
};
